import { Injectable } from "@angular/core";
import { CapitalNeed } from "@models/capitalNeed.model";
import BaseService from "./base.service";

/**
 * A variant of the BaseService where the CapitalNeed's information is stored.
 *
 * @class CapitalNeedsService
 * @augments {BaseService<CapitalNeed>}
 */
@Injectable({
  providedIn: "root",
})
export class CapitalNeedsService extends BaseService<CapitalNeed> {
  getAverageFiveYearCapitalNeeds(): number {
    const devs = this.getItems();
    const length = devs.length;

    return (
      devs.flatMap((c) => c.fiveYearCapitalNeeds).reduce((acc, curr) => acc + curr, 0) / length
    );
  }

  getAverageTwentyYearCapitalNeeds(): number {
    const devs = this.getItems();
    const length = devs.length;
    return (
      devs.flatMap((c) => c.twentyYearCapitalNeeds).reduce((acc, curr) => acc + curr, 0) / length
    );
  }

  getTwentyYearCapitalNeeds(): number {
    const devs = this.getItems();
    return (
      devs.flatMap((c) => c.twentyYearCapitalNeeds).reduce((acc, curr) => acc + curr, 0)
    );
  }
}
